module.exports = __webpack_public_path__ + "static/media/imageForForm.0b177ab3.png";